import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import LockGold from '../../../svg/LockGold.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';

class Password extends Component {
  state = {
    client: {
      password: '',
      password_confirmation: ''
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const { password = '', password_confirmation = '' } = this.state.client;
    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="Choose a password"
          subline="Passwords require 1 upper case letter, 1 lower case letter and a number."
          icon={<LockGold />}
        />

        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="password"
                placeholder="Password"
                type="password"
                value={password}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
                validations={{
                  // Password must contain 1 uppercase, 1 lowercase, 1 number, and be at least 8 characters long
                  matchRegexp: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="password_confirmation"
                placeholder="Password Confirmation"
                type="password"
                value={password_confirmation}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                disabled={password === ''}
                required
                validations={{
                  customValidation: function(values, value) {
                    return value === values.password;
                  }
                }}
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    const { name, value } = e.target;
    if (this.hasNoSpaces(value))
      this.setState({ client: { ...this.state.client, [name]: value } });
  };

  hasNoSpaces = str => {
    const regex = /^\S*$/; // a string consisting only of non-whitespaces
    return regex.test(str);
  };

  checkConfirmationMatch = () => {
    const { password, password_confirmation } = this.state.client;
    return (
      password && password_confirmation && password === password_confirmation
    );
  };

  handleClientUpdate = () => {
    const { client } = this.state;
    this.props.updateClient(client);
  };

  componentDidMount() {
    const { client } = this.props;
    this.setState({ client });
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default Password;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Password.js